import ActivateProductHeader from './ActivateProductHeader'
import HeaderLoader from './HeaderLoader'
import PurchaseHeader from './PurchaseHeader'

type Props = {
  isActivationRequired: boolean
  isLoading: boolean
}

const PurchaseModalHeader = ({ isActivationRequired, isLoading }: Props) => {
  if (isLoading) {
    return <HeaderLoader />
  }

  if (isActivationRequired) {
    return <ActivateProductHeader />
  }

  return <PurchaseHeader />
}

export default PurchaseModalHeader
